

import { ActionTypes } from "../constants/action-types";

const initialState = {
  newBlog: [],
  loading: false,
  error: null,
  totalBlogs: 0,
  archivedBlogsByTopic:[],
  latestBlogsByTopic:[],
};

export const uploadBlog = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.UPLOAD_BLOG_REQUEST:
    case ActionTypes.FETCH_BLOGS_REQUEST:
    case ActionTypes.UPDATE_BLOGS_REQUEST:
    case ActionTypes.DELETE_BLOGS_REQUEST:
   case ActionTypes.FETCH_BLOGS_TOPIC_REQUEST:
    
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionTypes.UPLOAD_BLOG_SUCCESS:
      console.log("reducer upload blog:", action.payload);
      return {
        ...state,
        loading: false,
        
        newBlog: Array.isArray(state.newBlog) ? [...state.newBlog, action.payload] : [action.payload], 

        totalBlogs: state.totalBlogs + 1,
        // newBlogId


      };

    case ActionTypes.FETCH_BLOGS_SUCCESS:
      console.log("Reducer Payload:", action.payload);
        // Group blogs by topic
  const grouped = action.payload.reduce((acc, blog) => {
    const topic = blog.topicName;
    if (!acc[topic]) acc[topic] = [];
    acc[topic].push(blog);
    return acc;
  }, {});

  const latest = {};
  const archived = {};

  Object.keys(grouped).forEach((topic) => {
    const sorted = grouped[topic].sort(
      (a, b) => b.id - a.id
    );
    latest[topic] = sorted.slice(0, 5);      // newest 5
    archived[topic] = sorted.slice(5);       // everything after 5 → older only
  });

  
      return {
        ...state,
        loading: false,
        totalBlogs: action.payload.length, // Update total count
        newBlog: action.payload, // Replace blogs with fetched data
         latestBlogsByTopic: latest, // ✅ For ReadMore
    archivedBlogsByTopic: archived, // ✅ For ViewArchive
      };

    case ActionTypes.UPDATE_BLOGS_SUCCESS:
      console.log("Before Update:", state.newBlog);
      console.log("Updating Blog with ID:", action.payload.id);

      const updatedBlogs = state.newBlog.map((blog) =>
        blog.id === action.payload.id ? action.payload : blog
      );

      console.log("After Update:", updatedBlogs);

      return {
        ...state,
        newBlog: updatedBlogs,
        totalBlogs: updatedBlogs.length,
      };

    case ActionTypes.DELETE_BLOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        newBlog: state.newBlog.filter((blog) => blog.id !== action.payload),
        totalBlogs: Math.max(0, state.totalBlogs - 1), // Prevent negative count
      };

 
case ActionTypes.FETCH_BLOGS_TOPIC_SUCCESS: {
  console.log("Sample payload:", action.payload[0]);

  const grouped = action.payload.reduce((acc, blog) => {
        const topic = blog.topicName;
        if (!acc[topic]) acc[topic] = [];
        acc[topic].push(blog);
        return acc;
      }, {});

      const latestBlogsByTopic = {};
      const archivedBlogsByTopic = {};
      

      Object.keys(grouped).forEach(topic => {
     
  const sorted = grouped[topic].sort(
    (a, b) => a.id - b.id
  );

  // Latest 5 = take from the END
  latestBlogsByTopic[topic] = sorted.slice(-5).reverse(); 

  // Archived = everything EXCEPT last 5 (i.e., older ones)
  // archivedBlogsByTopic[topic] = sorted.slice(0, sorted.length - 5);
      archivedBlogsByTopic[topic] = sorted.slice(0, Math.max(0, sorted.length - 5));


  console.log("Sorted:", sorted.map(b => b.id));
  console.log("Latest:", latestBlogsByTopic[topic].map(b => b.id));
  console.log("Archive:", archivedBlogsByTopic[topic].map(b => b.id));

  
})

      return {
        ...state,
        loading: false,
        latestBlogsByTopic,
        archivedBlogsByTopic,
      };
    }

    case ActionTypes.FETCH_BLOGS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    



      

    
     

    case ActionTypes.UPLOAD_BLOG_FAILURE:
    case ActionTypes.FETCH_BLOGS_FAILURE:
    case ActionTypes.UPDATE_BLOGS_FAILURE:
    case ActionTypes.DELETE_BLOGS_FAILURE:
    case ActionTypes.FETCH_BLOGS_TOPIC_FAILURE:  
    case ActionTypes.FETCH_ARCHIVE_BLOGS_FAILURE:
    // case ActionTypes.SAVE_BLOG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default uploadBlog;

